import { OrderStatus } from "@/shared/utils/enum";
import { OrderV2 } from "@/shared/v2/queries/interfacesV2";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Icon from "../Icon/Icon";import Tooltip from "@/Components/Tooltip/Tooltip";

const text = {
  9: "readyForPackaging",
  2: "cartitemstatus2"
};

const icon = {
  9: "clipboardcheck",
  2: "spinner"
};

const OrderKitchenStatus = ({ order }: {order: OrderV2;}) => {
  const { order_status } = order.order_information;
  const { t } = useTranslation("", { keyPrefix: "order" });

  const isPending = useMemo(() => {
    return (
      order.cart_content.some(
        (item) => item.type === "1" && item.kitchen_status !== 1
      ) && order_status === OrderStatus.IN_KITCHEN);

  }, [order]);

  return (
    (isPending || order_status === OrderStatus.READY_FOR_PACKAGING) &&
    <>
        <Tooltip content=

      {t(text[isPending ? 2 : order_status])}><div><div className="ml-[1rem]">
            
          <Icon
              className={`fill-primary ${isPending ? "h-6 w-6" : "h-5 w-5"}`}
              variants={icon[isPending ? 2 : order_status]}
            />
            
        </div></div></Tooltip>
      </>);


};

export default OrderKitchenStatus;